<template>
	<div class="outer-box">
		<h4>Email Verification</h4>
		<div class="inner-box" style="text-align: left; width: 500px">
			<input
				class="hl_input--wrap"
				type="text"
				placeholder="Contact Id"
        v-model="contactId"
			/>
      <input
				class="mt-4 hl_input--wrap"
				type="text"
				placeholder="Email Address"
        v-model="email"
			/>
      <div class="mt-4">Verification Status</div>
      <select class="hl_input--wrap" type="text" v-model="verificationStatus">
        <option value=true>True</option>
        <option value=false>False</option>
      </select>
			<button class="btn btn-primary mt-4" @click="setVerificationStatus">
				<span> Set Verification Status </span>
			</button>
      <div class="code-wrapper" style="position: relative" v-if="response">
				<pre
					id="text-copy"
					style="background-color: #f2f7fa; padding: 16px; margin-top: 16px"
					>{{ response }}</pre
				>
			</div>
      <p v-if="error" class="error">
      {{ error }}
    </p>
		</div>
	</div>
</template>

<script>
  import { EmailISVService } from '@/services';

  export default {
    data() {
      return {
        contactId: "",
        email: "",
        verificationStatus: false,
        error:null,
        options: [
          {
            value: true,
            label: true,
          },
          {
            value: false,
            label: false,
          }
        ],
        processing: false,
        response: null
      };
    },
    methods: {
      setVerificationStatus(){
        this.processing = true
        this.error = null
        if(!this.email){
          this.error = "Please enter email address"
          return false;
        }

        if(!this.contactId){
          this.error = "Please enter contact id"
          return false;
        }

        if(this.email){
          const emailMatches = this.email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/gim)
          if(!emailMatches || !emailMatches.length){
            this.error = "Please enter valid email address";
            return false;
          }
        }

        EmailISVService.setVerificationStatus(this.email, this.contactId, this.verificationStatus=='true')
        .then(response => {
          this.response = response.data
        })
        .catch(error => {
          this.error = error.response.data
        })
        .finally(() => {
          this.processing = false;
        });
      },
    }

  }
</script>
